import {
    ChangeDetectionStrategy,
    Renderer2,
    Component,
    ElementRef,
    Input,
    OnInit,
    OnDestroy,
    OnChanges,
    SimpleChanges
} from '@angular/core';
import { Client } from '@df/core/service/client';
import { Subscription } from 'rxjs';
import { BottomPanelService } from './bottom-panel.service';

@Component({
    selector: 'bottom-panel',
    templateUrl: './bottom-panel.html',
    styleUrls: ['./bottom-panel.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class BottomPanelComponent implements OnChanges, OnInit, OnDestroy {
    private restrictionSubscription?: Subscription;
    private scrollSubscription?: Subscription;

    @Input()
    bottomPanelRestricted?: string[];

    /**
     * It may be that restricting elements are visible right away
     * In that case we set rule that the element can only be hiddne if scrollTop > 5
     */
    @Input()
    onTopForce = true;

    @Input()
    forceHideAtTop = 0;

    private visible = false;

    constructor(
        private elementRef: ElementRef,
        private bottomPanelService: BottomPanelService,
        private renderer2: Renderer2,
        private client: Client
    ) {}

    ngOnInit() {
        this.onTopForceChange();
    }

    ngOnDestroy(): void {
        this.restrictionSubscription?.unsubscribe();
        this.scrollSubscription?.unsubscribe();
        this.elementRef.nativeElement.remove();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['bottomPanelRestricted']) {
            this.restrictionSubscription?.unsubscribe();
            this.restrictionSubscription = new Subscription();
            if (this.bottomPanelRestricted) {
                this.restrictionSubscription.add(
                    ...this.bottomPanelRestricted.map(id => this.bottomPanelService.observe(id).subscribe(() => this.update()))
                );
            } else {
                this.update();
            }
        }
        if (changes['onTopForce']) {
            this.onTopForceChange();
        }
    }

    private onTopForceChange() {
        this.scrollSubscription?.unsubscribe();
        if (this.onTopForce) {
            this.scrollSubscription = this.client.obs.scroll.subscribe(() => this.update());
        }
    }

    private update(): void {
        const shouldBeVisible =
            (!this.bottomPanelRestricted?.find(id => this.bottomPanelService.getState(id).obs.value) ||
                (this.onTopForce && this.client.getRootElement().scrollTop < 5)) &&
            !(this.forceHideAtTop && this.client.getRootElement().scrollTop < this.forceHideAtTop);

        if (this.visible !== shouldBeVisible) {
            this.visible = shouldBeVisible;
            !this.visible
                ? this.renderer2.addClass(this.elementRef.nativeElement, '_hidden')
                : this.renderer2.removeClass(this.elementRef.nativeElement, '_hidden');
        }
    }
}
